import React from 'react';

export const metadata = {
  "name": "JavaScript",
  "link": "/javascript"
};

export default function Javascript() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">JavaScript</h1>
      <p>Link: /javascript</p>
      <pre>{JSON.stringify(metadata, null, 2)}</pre>
    </div>
  );
}
